import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setCurrentFaccao, } from '../actions/';
import { Link } from 'react-router-dom';
import CardsQualidade from './CardsQualidade';
import { groupByType } from '../utils/Functions';
import './CardFaccao.css';

export default function CardFaccao({ codigo, nome, toggleModal }) {
    const dispatch = useDispatch();
    const [pedidosFaccao, setPedidosFaccao] = React.useState([]);
    const [pedidosCriticos, setPedidosCriticos] = React.useState([]);
    const pvs = useSelector(state => state.dataPvState.data);
    const pedidos = useSelector(state => state.pedidoState);

    React.useEffect(() => {
        const loadData = () => {
            let ped = [];
            let pedCrit = [];
            pedidos.length > 0 &&
                pvs.map(e => {
                    ped = [
                        ...ped,
                        ...groupByType(pedidos.filter(p => p.PERPLAN === e && p.LIFNR === codigo && !(p.REMESSA_FINAL === 'X' && p.QMNUM))),
                    ];
                    pedCrit = [
                        ...pedCrit,
                        ...groupByType(
                            pedidos.filter(
                                p =>
                                    p.PERPLAN === e &&
                                    p.LIFNR === codigo &&
                                    p.LISTA_CRITICA === 'X' &&
                                    !(p.REMESSA_FINAL === 'X' && p.QMNUM)
                            )
                        ),
                    ];
                    return true;
                });
            setPedidosCriticos(pedCrit.length);
            setPedidosFaccao(ped.length);
        };
        loadData();
    }, [pvs, pedidos]);

    const handleDelete = async (e, value, label) => {
        e.preventDefault();
        toggleModal(value, label);
    }

    return (
        <Link
            to={`${window.location.href.includes('qualidade/') ? '/qualidade' : '/auditoria'}/faccao/${codigo}`}
            onClick={() => dispatch(setCurrentFaccao({ codigo, nome, pedidosFaccao, pedidosCriticos }))}
            style={{ width: '100%', textDecoration: 'none' }}
            className='link'
        >
            <div className='card py-2 px-3 my-1 w-100 MaterialShadow' style={{ cursor: 'pointer' }}>
                <div className='row pb-1'>
                    <div className='col-sm-8'>
                        {nome} 
                        <i 
                            className='fa fa-trash' 
                            style={{marginLeft: '10px', width: '50px', cursor: 'pointer', fontSize: '20px'}}
                            onClick={(e) => {handleDelete(e, codigo, nome)}}
                        ></i> 
                        <br></br>
                        <span className='second-color'> ({codigo.slice(3, 10)})</span>
                    </div>
                    <div className='col-sm-4'>
                        <CardsQualidade pedidos={pedidosFaccao} criticos={pedidosCriticos}></CardsQualidade>
                    </div>
                </div>
            </div>

           
        </Link>
    );
}
